function RegWelcome() {
  return (
    <div className="col-md-8 m-auto">
      <div className="reg-card text-center py-10 px-20">
        <div className="m-auto">
          <img
            src={require("../assets/logo.png")}
            alt=""
            className="text-center inline"
            width={150}
          />
        </div>
        <h2 className="text-2xl font-bold mb-2">Congratulations 🎉</h2>
        <p className="text-xl font-bold mb-2">Welcome to IndianMSME</p>
        <p className="text-lg mb-4">
          Thank you for choosing to be a part of IndianMSME. Your registration
          is complete, and we're excited to have you on board. Get ready to
          explore, connect, and enjoy all the benefits of being a member. If you
          have any questions or need assistance, feel free to reach out.
        </p>
        <p className="text-xl font-bold mb-4">
          Helpline Number:- +91-8800001259, +91-9990060509
        </p>
      </div>
    </div>
  );
}

export default RegWelcome;
